module.exports = __webpack_public_path__ + "static/media/facility.cc8d7a3d.svg";